import { render, staticRenderFns } from "./employerJobList.vue?vue&type=template&id=6555523c&scoped=true"
import script from "./employerJobList.vue?vue&type=script&lang=js"
export * from "./employerJobList.vue?vue&type=script&lang=js"
import style0 from "./employerJobList.vue?vue&type=style&index=0&id=6555523c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6555523c",
  null
  
)

export default component.exports